import areaList from "@/libs/areaList";
import areaSelection from "@/components/areaSelection.vue";
import { getAddressDetail, getUpdateAddress, getAddAddress, getDelAddress } from "@/libs/api";
export default {
	name: "addAddress",
	components: { areaSelection },
	data() {
		return {
			areaList,
			active: 2,
			isDefault: false,
			id: "",
			title: "新增收货地址",
			isShow: false,
			postalCode: "",
			selName: "",
			selectArea: {
				postCode: "",
				list: [
					{
						name: "",
						adcode: "",
						isDisplay: false,
					},
					{
						name: "",
						adcode: "",
						isDisplay: false,
					},
					{
						name: "",
						adcode: "",
						isDisplay: false,
					},
					{
						name: "",
						adcode: "",
						isDisplay: false,
					},
				],
			},
			addrInfo: {
				phoneNumber: "",
				userName: "",
				postalCode: "",
			},
			searchResult: [],
		};
	},

	mounted() {
		this.id = this.$route.query.id || "";
		// 修改收货地址
		if (this.id) {
			this.title = "修改收货地址";
			this.getAddressDetail();
		}
	},
	methods: {
		// 弹出地区选择
		popArea() {
			this.isShow = true;
			this.$refs.selectArea.onGetAress();
		},
		closeAction(res) {
			this.postalCode = this.selectArea.postCode;
			this.selName = this.selectArea.list
				.map(function(item) {
					if (item.adcode) return item.name;
				})
				.join(" ");
			this.isShow = res;
		},
		getAreaData(data) {
			this.selectArea = data;
		},
		setValues() {
			console.log("setValues");
		},
		// 删除地址
		onDelete(addressId) {
			if (this.id) {
				addressId = this.id;
			}
			this.$dialog
				.confirm({
					title: "温馨提示",
					message: "确定要删除地址吗?",
				})
				.then(() => {
					// on confirm
					getDelAddress({ addressId: addressId }, "jsonCallback").then((res) => {
						if (res.code == "0000") {
							this.$toast("删除地址成功");
							this.$router.go(-1);
						}
					});
				})
				.catch(() => {
					// on cancel
					console.log("on cancel");
				});
		},
		// 获取地址详情
		getAddressDetail() {
			getAddressDetail({ addressId: this.id }, "jsonCallback").then((res) => {
				let addr = res.address;
				this.addrInfo = addr;
				this.isDefault = /1/.test(addr.ismyprimaryaddress);
				this.postalCode = addr.postalCode;
				this.selectArea = {
					postCode: this.postalCode,
					list: [
						{
							name: addr.provinceName,
							adcode: addr.provinceId,
							isDisplay: true,
						},
						{
							name: addr.cityName,
							adcode: addr.cityId,
							isDisplay: true,
						},
						{
							name: addr.areaName,
							adcode: addr.areaId,
							isDisplay: true,
						},
						{
							name: addr.townName,
							adcode: addr.townId,
							isDisplay: true,
						},
					],
				};
				this.selName = this.selectArea.list
					.map(function(item) {
						if (item.adcode) return item.name;
					})
					.join(" ");
			});
		},
		onSave(content) {
			let list = this.selectArea.list;
			let data = {
				provinceName: list[0].name,
				provinceId: list[0].adcode,
				cityName: list[1].name,
				cityId: list[1].adcode,
				areaName: list[2].name,
				areaId: list[2].adcode,
				townName: list[3].name,
				townId: list[3].adcode,
				postalCode: this.postalCode,
				ismyprimaryaddress: this.isDefault ? "1" : "0",
			};
			Object.assign(this.addrInfo, data);
			console.log("save");
			if (this.id) {
				// 修改
				getUpdateAddress(this.addrInfo, "jsonCallback").then((res) => {
					console.log(res);
					if (res.code == "0000") {
						this.$toast(res.msg);
						this.$router.go(-1);
					} else {
						this.$toast(res.msg);
					}
				});
			} else {
				// 新增地址
				console.log("add");
				getAddAddress(this.addrInfo, "jsonCallback").then((res) => {
					console.log(res);
					this.$toast(res.msg);
					if (res.code == "0000") {
						this.$router.go(-1);
					} else {
						this.$toast(res.msg);
					}
				});
			}
		},
		// onDelete(content) {
		// console.log(content);

		// 	if (!this.id) {
		// 		this.$toast("error");
		// 		return false;
		// 	}
		// 	getDelAddress({ addressId: this.id }, "jsonCallback").then((res) => {
		// 		console.log(res);
		// 		if (res.code == "0000") {
		// 			this.$toast(res.msg);
		// 			this.$router.go(-1);
		// 		}
		// 	});
		// },
		onChangeArea(area) {
			console.log(area);
		},
		onChangeDetail(val) {
			if (val) {
				this.searchResult = [
					{
						name: "黄龙万科中心",
						address: "杭州市西湖区",
					},
				];
			} else {
				this.searchResult = [];
			}
		},
	},
};
